import React from "react";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";
import { isString } from "lodash";

import { Input } from "semantic-ui-react";

import WithFormField from "../WithFormField";

export function ControlledInput({
  name,
  defaultValue,
  required,
  errorMessage,
  type,
  ...props
}) {
  const {
    field,
    fieldState: { error },
  } = useController({
    name: name,
    defaultValue: defaultValue,
    rules: {
      validate: (value) => {
        return required && isString(value)
          ? Boolean(value?.trim().length) || errorMessage
          : true;
      },
      required: { value: required, message: errorMessage },
    },
  });

  return (
    <Input
      {...props}
      type={type}
      value={field.value || ""}
      onChange={field.onChange}
      onBlur={field.onBlur}
      ref={field.ref}
      error={Boolean(error?.message)}
    />
  );
}

ControlledInput.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
};

ControlledInput.defaultProps = {
  type: undefined,
  defaultValue: "",
  required: false,
  errorMessage: "",
};

export default WithFormField(ControlledInput);
